module.exports = __webpack_public_path__ + "static/media/arrow-icon-grey.057df290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-icon-grey.svg
// module id = 259
// module chunks = 0